export const CHANGE_TAB = 'change tab';
export const CHANGE_SIZE = 'resize map';
export const UPDATE_UI_PROPERTY = 'update ui property';
export const FULLY_LOADED = 'fully loaded';
export const CHANGE_VIEW = 'change view';
export const TOGGLE_PORT = 'toggle port';
export const TOGGLE_SHIPYARD = 'toggle shipyard';

export const changeTab = (data) => ({
  type: CHANGE_TAB,
  payload: data
});

export const resizeMap = (data) => ({
  type: CHANGE_SIZE,
  payload: data
});

export const updateUiProperty = (data) => ({
  type: UPDATE_UI_PROPERTY,
  payload: data
});

export const fullyLoaded = () => ({
  type: FULLY_LOADED,
});

export const changeView = (data) =>({
  type: CHANGE_VIEW,
  payload: data
})

export const togglePort = () =>({
  type: TOGGLE_PORT
})

export const toggleShipyard = () =>({
  type: TOGGLE_SHIPYARD
})